import * as React from 'react';
import {
    IAuthorisationStore
} from './authorisation-store';
import { createAuthorisationStore } from '@services/factories';

export const authorisationContext = React.createContext<IAuthorisationStore | null>(null);

interface ProviderProps {

}

interface ProviderState {
    store: IAuthorisationStore;
}

export class AuthorisationProvider extends React.Component<ProviderProps, ProviderState> {
    state = {
        store: createAuthorisationStore()
    };

    render() {
        return (
            <authorisationContext.Provider value={this.state.store}>
                { this.props.children }
            </authorisationContext.Provider>
        );
    }
}

export const useAuthorisation = () => React.useContext(authorisationContext);



// WEBPACK FOOTER //
// ./src/stores/authorisation/authorisation-context.tsx